import { Percent, DollarSign, Tag } from 'lucide-react'
import { fmtMoneda } from '@/lib/cd2bPricing'

/**
 * DescuentoInput — descuento/promoción sobre el MENSUAL que el asesor negocia. Controlado por el
 * padre: `descuento` = {tipo:'percent'|'amount', valor, motivo, mesesPromo} | null; `setDescuento`.
 * `mesesPromo` vacío = descuento PERMANENTE; con N = promo temporal (el checkout arma un cupón que
 * revierte al precio lleno tras N meses). Muestra en vivo cuánto baja el mensual.
 */
export default function DescuentoInput({ descuento, setDescuento, moneda = 'USD', montoDescuento = 0, precioFull = 0 }) {
  const activo = !!descuento
  const d = descuento || { tipo: 'percent', valor: '', motivo: '', mesesPromo: '' }
  const set = (campo, valor) => setDescuento({ ...d, [campo]: valor })

  return (
    <div className="rounded-lg border border-line bg-card p-3">
      <label className="flex items-center gap-2 text-body-sm text-foreground cursor-pointer min-h-10">
        <input type="checkbox" className="h-4 w-4 accent-primary" checked={activo}
          onChange={(e) => setDescuento(e.target.checked ? { tipo: 'percent', valor: '', motivo: '', mesesPromo: '' } : null)} />
        <Tag size={14} className="text-primary-700 dark:text-primary-300" />
        <span className="font-medium">Aplicar descuento / promoción</span>
      </label>

      {activo && (
        <div className="mt-3 space-y-2.5">
          <div className="flex flex-wrap items-end gap-2">
            {/* Tipo % o $ */}
            <div className="inline-flex h-10 rounded-md border border-line overflow-hidden">
              <button type="button" onClick={() => set('tipo', 'percent')}
                className={`px-3 text-body-sm flex items-center gap-1 ${d.tipo === 'percent' ? 'bg-primary text-white' : 'bg-card text-subtle hover:bg-surface-muted'}`}>
                <Percent size={13} /> %
              </button>
              <button type="button" onClick={() => set('tipo', 'amount')}
                className={`px-3 text-body-sm flex items-center gap-1 border-l border-line ${d.tipo === 'amount' ? 'bg-primary text-white' : 'bg-card text-subtle hover:bg-surface-muted'}`}>
                <DollarSign size={13} /> {moneda}
              </button>
            </div>
            <div className="min-w-0">
              <label className="text-caption text-neutral-500 dark:text-neutral-400 block mb-0.5">{d.tipo === 'percent' ? 'Porcentaje' : 'Monto/mes'}</label>
              <input type="number" min="0" step={d.tipo === 'percent' ? '1' : '0.01'} max={d.tipo === 'percent' ? '100' : undefined}
                value={d.valor} onChange={(e) => set('valor', e.target.value)}
                className="h-10 w-24 rounded-md border border-line bg-card px-2 text-body-sm text-foreground tabular-nums" placeholder={d.tipo === 'percent' ? '10' : '5.00'} />
            </div>
            <div className="min-w-0">
              <label className="text-caption text-neutral-500 dark:text-neutral-400 block mb-0.5">Solo N meses <span className="text-neutral-400 dark:text-neutral-500">(opcional)</span></label>
              <input type="number" min="0" step="1" value={d.mesesPromo}
                onChange={(e) => set('mesesPromo', e.target.value)}
                className="h-10 w-24 rounded-md border border-line bg-card px-2 text-body-sm text-foreground tabular-nums" placeholder="permanente" />
            </div>
          </div>
          <input type="text" value={d.motivo} onChange={(e) => set('motivo', e.target.value)}
            className="h-10 w-full rounded-md border border-line bg-card px-2.5 text-body-sm text-foreground" placeholder="Motivo (ej.: lanzamiento, cliente referido, cierre de trimestre)" />
          {montoDescuento > 0 && (
            <p className="text-caption text-success-700 dark:text-success-300">
              Baja {fmtMoneda(montoDescuento, moneda)}/mes{Number(d.mesesPromo) > 0 ? ` por ${Math.floor(Number(d.mesesPromo))} meses` : ''}.
              {precioFull > 0 && Number(d.mesesPromo) > 0 && <> Luego vuelve a {fmtMoneda(precioFull, moneda)}/mes.</>}
            </p>
          )}
        </div>
      )}
    </div>
  )
}
